import { StorageService } from './storageService';

const API_BASE_URL = '/practice-exams/api';

export interface NotificationItem {
  _id: string;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'pro' | 'remediation' | 'milestone';
  isRead: boolean;
  isDismissed: boolean;
  createdAt: string;
  link?: string;
  // Added certId and targetTier to satisfy TypeScript requirements in management components like NotificationManager
  certId?: string;
  targetTier?: 'all' | 'free' | 'paid';
}

export const NotificationService = {
  getNotifications: async (userId: string, archived: boolean = false): Promise<NotificationItem[]> => {
    const res = await fetch(`${API_BASE_URL}/notifications/${userId}?archived=${archived}`);
    if (!res.ok) return [];
    return await res.json();
  },

  updateStatus: async (userId: string, notificationId: string, action: 'read' | 'dismiss') => {
    const res = await fetch(`${API_BASE_URL}/notifications/status`, {
      method: 'POST',
      headers: StorageService.getAuthHeader(),
      body: JSON.stringify({ userId, notificationId, action })
    });
    return res.ok;
  },

  adminCreate: async (data: Partial<NotificationItem>) => {
    const res = await fetch(`${API_BASE_URL}/notifications/admin`, {
      method: 'POST',
      headers: StorageService.getAuthHeader(),
      body: JSON.stringify(data)
    });
    return await res.json();
  },

  adminGetAll: async (): Promise<NotificationItem[]> => {
    const res = await fetch(`${API_BASE_URL}/notifications/admin/all`, {
      headers: StorageService.getAuthHeader()
    });
    if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        throw new Error(error.error || "Failed to retrieve broadcast history");
    }
    return await res.json();
  },

  adminSuggestAI: async (context: string) => {
    const res = await fetch(`${API_BASE_URL}/notifications/admin/suggest`, {
      method: 'POST',
      headers: StorageService.getAuthHeader(),
      body: JSON.stringify({ context })
    });
    return await res.json();
  }
};